"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringMaxLengthOr = exports.forEach = exports.booleanToYesNo = exports.stringToBoolean = exports.pluralIfNeeded = void 0;
function pluralIfNeeded(count, suffix = 's', singleSuffix = '') {
    if (!Number.isNaN(count) && count !== 1) {
        return suffix;
    }
    return singleSuffix;
}
exports.pluralIfNeeded = pluralIfNeeded;
function stringToBoolean(string) {
    if (typeof string === 'string') {
        string = string.trim().toUpperCase();
        return string === 'TRUE' || string === '1';
    }
    return !!string;
}
exports.stringToBoolean = stringToBoolean;
function booleanToYesNo(boolean) {
    return boolean ? 'Yes' : 'No';
}
exports.booleanToYesNo = booleanToYesNo;
function forEach(string, cb) {
    let i = 0, iMax = 0;
    if (typeof (cb) !== "function") {
        throw new TypeError(`forEach: callBack should be function, ${typeof cb} given`);
    }
    for (i = 0, iMax = string.length; i < iMax; i += 1) {
        cb(string.charAt(i), i);
    }
}
exports.forEach = forEach;
const ellipseString = (string, maxLength) => {
    const ellipse = '...';
    let trimLength = 0;
    if (string.length > ellipse.length && maxLength > ellipse.length) {
        trimLength = ellipse.length;
    }
    return (string.substring(0, maxLength - trimLength)) + (maxLength > ellipse.length ? ellipse : '');
};
function stringMaxLengthOr(string, maxLength, useEllipse = true, or = '') {
    if (!string || typeof (string) !== 'string') {
        string = or;
    }
    if (string.length > maxLength) {
        return useEllipse ? ellipseString(string, maxLength) : string.substring(0, maxLength);
    }
    else {
        return string;
    }
}
exports.stringMaxLengthOr = stringMaxLengthOr;
//# sourceMappingURL=index.js.map